/*
**  rui-well.js
**
**  rui-well component
*/
import { LitElement, html, css } from 'lit-element';
export class RuiWell extends LitElement {
    static get is() {
        return 'rui-well';
    }
    static get properties() {
        return {};
    }
    constructor() {
        super();
    }
    render() {
        return html `
            <div class="rui-well">
                <slot></slot>
            </div>
        `;
    }
    static get styles() {
        return css `
            .rui-well {
                background-color: var(--well-bg, #eef3f6);
                border-style: none;
                border-radius: 3px;
                padding: 10px;
            }

            @media print {
                .rui-well {
                    background-color: transparent;
                }
            }
        `;
    }
}
customElements.get(RuiWell.is) || customElements.define(RuiWell.is, RuiWell);
